import { useEffect, useState } from 'react';
import API from '../api/axios';

export default function PostList() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    API.get('/posts').then(res => setPosts(res.data));
  }, []);

  // Determine the base URL for images based on environment
  const getImageUrl = (imagePath) => {
    const backendUrl = process.env.REACT_APP_API_URL 
      ? process.env.REACT_APP_API_URL.replace('/api', '') 
      : 'https://syntexhub-blog-app.onrender.com';
    return `${backendUrl}/uploads/${imagePath}`;
  };

  return (
    <div className="posts-grid">
      {posts.map(post => (
        <div className="post-card" key={post._id}>
          <div className="post-image-container">
            {post.image && <img src={getImageUrl(post.image)} alt={post.title} className="post-card-img" />}
          </div>
          <div className="post-card-body">
            <h2 className="post-card-title">{post.title}</h2>
            <p className="post-card-text">{post.content}</p>
            <small>By {post.author?.username}</small>
          </div>
        </div>
      ))}
    </div>
  );
}